import * as React from 'react'
import './App.css'
import UserSession from './Components/UserSession'
import Internationalization from './internationalization'
import Routes from './routes'
import { useDispatch, useSelector } from 'react-redux'
import { setAccountCategoryVerificationStatus, setEmailVerificationStatus, setFrProUser, setMobileVerificationStatus, setOtherUserInfo } from './store/reducers/Users/users'
import { LoginApis } from './API/Login/LoginApi'
import { useLocation, useNavigate } from 'react-router-dom'
import { AccountCategoryAPIs } from './API/AccountCategory/AccountCategoryAPI'
import { ProfileApis } from './API/Login/ProfileApi'
import { setFollowersList } from './store/reducers/Followers/Followers'
import { setFollowingList } from './store/reducers/Following/Following'
import { $pres } from 'strophe.js'
import { StropheContext } from './Pages/ChatClient'

function App() {
  const location = useLocation();
  const [authToken, setAuthToken] = React.useState(null);
  const [authReady, setAuthReady] = React.useState(false);
  const { frProUser } = useSelector((state) => state.Users)
  // const pathSegments = location.pathname.split('/')[1];
  const stropheContext = React.useContext(StropheContext)

  // const logoutClicked = () => {
  //   let logoutdata = {
  //     fre8ProAccessToken: frProUser?.fre8ProAccessToken,
  //     operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
  //     operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
  //     clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
  //   }
  //   LoginApis.logout(logoutdata)
  //     .then((res) => {
  //       // dispatch(setUser({ user: res }));
  //       window.location.reload()
  //       if (pathSegments === 'csr') {
  //         navigate('/csr')
  //       } else {
  //         navigate('/')
  //       }
  //       // console.log('logged out', res)
  //       // alert("Logged out")
  //       // dispatch(setUser({ user: {} }));
  //       dispatch(setFrProUser({ frProUser: {} }))
  //       dispatch(setOtherUserInfo({ otherUserInfo: {} }))
  //       dispatch(setFollowersList({ followersList: [] }))
  //       dispatch(setFollowingList({ followingList: [] }))
  //       dispatch(setEmailVerificationStatus(null))
  //       dispatch(setMobileVerificationStatus(null))
  //       dispatch(setAccountCategoryVerificationStatus(null))
  //       // window?.connectionObj?.disconnect();
  //       var check = $pres({
  //         type: 'unavailable',
  //       })
  //       // window?.connectionObj?.send(check);
  //       // window?.connectionObj?.disconnect();
  //       // window.connectionObj = null;
  //       stropheContext?.connectionObj?.send(check)
  //       stropheContext?.connectionObj?.disconnect()
  //       stropheContext?.setconnectionObj(null) // TODO: Set conenction obj null
  //       localStorage.setItem('user', JSON.stringify({}))
  //       localStorage.removeItem('mainPageUrl')
  //       localStorage.removeItem('Authorization')
  //     })
  //     .catch((err) => {
  //       // alert("logout  failed", err)
  //       // navigate("/error", { err: err })
  //       var check = $pres({
  //         type: 'unavailable',
  //       })
  //       // window?.connectionObj?.send(check);
  //       // window?.connectionObj?.disconnect();
  //       stropheContext?.connectionObj?.send(check)
  //       stropheContext?.connectionObj?.disconnect()
  //       stropheContext?.setconnectionObj(null) // TODO: Set conenction obj null
  //       console.log('logout error', err)
  //       // let customMessage = 'Logout failed'
  //       // let type = 'User Information'
  //       // let color = 'red'
  //       // ErrorHandle(err, setToasts, customMessage, type, color)
  //     })
  //     .finally(() => {
  //       // TODO: remove test code
  //       if (pathSegments === 'csr') {
  //         navigate('/csr')
  //       } else {
  //         navigate('/')
  //       }

  //     })
  // }

  const logoutClicked = async () => {
    let logoutdata = {
      fre8ProAccessToken: frProUser?.fre8ProAccessToken,
      operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
      operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
      clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
    };

    try {
      // ✅ IMPORTANT: return/await API
      const res = await LoginApis.logout(logoutdata);

      // Cleanup redux
      dispatch(setFrProUser({ frProUser: {} }));
      dispatch(setOtherUserInfo({ otherUserInfo: {} }));
      dispatch(setFollowersList({ followersList: [] }));
      dispatch(setFollowingList({ followingList: [] }));
      dispatch(setEmailVerificationStatus(null));
      dispatch(setMobileVerificationStatus(null));
      dispatch(setAccountCategoryVerificationStatus(null));

      // Disconnect XMPP safely
      const check = $pres({ type: 'unavailable' });
      stropheContext?.connectionObj?.send(check);
      stropheContext?.connectionObj?.disconnect();
      stropheContext?.setconnectionObj(null);

      // Clear storage
      localStorage.setItem('user', JSON.stringify({}));
      localStorage.removeItem('mainPageUrl');
      localStorage.removeItem('Authorization');

      return res; // ✅ THIS MAKES await WORK
    } catch (err) {
      console.error('logout error', err);
      throw err; // ✅ propagate error
    }
  };


  React.useEffect(() => {
    const initAuth = async () => {
      const params = new URLSearchParams(location.search);
      const urlToken = params.get("Authorization");
      const storedToken = localStorage.getItem("Authorization");

      let finalToken = null;

      // 1️⃣ If URL token exists
      if (urlToken) {
        // 🔥 Only logout if token is DIFFERENT
        if (storedToken && storedToken !== urlToken) {
          await logoutClicked(); // ✅ WAIT here
        }

        localStorage.setItem("Authorization", urlToken);
        localStorage.setItem("mainPageUrl", "pro");
        finalToken = urlToken;

        // remove token from URL
        window.history.replaceState({}, "", location.pathname);
      }
      // 2️⃣ Fallback to stored token
      else if (storedToken) {
        finalToken = storedToken;
      }

      // 3️⃣ Set token AFTER logout finishes
      if (finalToken) {
        setAuthToken(finalToken);
      }

      // 4️⃣ Mark auth ready LAST
      setAuthReady(true);
    };

    initAuth();
    // const params = new URLSearchParams(location.search);
    // const urlToken = params.get("Authorization");
    // const storedToken = localStorage.getItem("Authorization");

    // if (urlToken) {
    //   localStorage.setItem("mainPageUrl", "pro");
    //   localStorage.setItem("Authorization", urlToken);
    //   setAuthToken(urlToken);
    //   // 🔥 remove token from URL (VERY IMPORTANT)
    //   window.history.replaceState({}, "", location.pathname);
    // } else if (storedToken) {
    //   setAuthToken(storedToken);
    // }

    // setAuthReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, location.pathname]);



  // const params = new URLSearchParams(location.search);
  // const authorization = params.get("Authorization");
  // console.log('-----------authorization------>', authorization)
  // React.useEffect(() => {
  //   if (authorization) {
  //     localStorage.setItem('Authorization', authorization);
  //     localStorage.setItem('mainPageUrl', 'pro')
  //   }
  // }, [authorization])

  const navigate = useNavigate()
  const dispatch = useDispatch()
  // const fre8Token = params.get("fre8ProAccessToken");
  // const auth = useSearchParams.get("Authorization")
  // console.log('location---->APP---', location)
  // console.log('authorization---->APP---', authorization)
  // React.useEffect(() => {
  //   const params = new URLSearchParams({ Authorization: 'eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoidXNlciIsInNhbHQiOiI4QXV0bHNYeXF6Iiwib3BlYXJ0ZWRCeU1vZHVsZSI6IkZSRThQUk8iLCJjcmVhdGlvblRpbWUiOiIxNzY2NTc2OTI0NDA4IiwidHlwZSI6IkJlYXJlciIsImFjY2Vzc1Rva2VuIjoiRjRCNjY3QkI1NDQwMjE2NUFBRDRFNUI5QjAyOTJBNDQiLCJ1c2VyTmFtZSI6InRlc3R1c2VyMTkiLCJ1c2VySWQiOiJmYTZhYzc2My04ZGMxLTQzMmEtODhmYi1jNjVlMDQ0ZWZhMzYiLCJleHBpcmVzaW4iOiIxNzY2NjYzMzI0NDA4Iiwic2NvcGUiOiJ1c2VyIiwidXNlclR5cGUiOiIiLCJncmFudFR5cGUiOiJwYXNzd29yZCIsIm9wZWFydGVkQnlVc2VySWQiOiJkOTc0MjU5Yy04OGJiLTQ5ZWYtYmU5ZS1jZDc5MGI5MTMzNjUiLCJyZWZyZXNoVG9rZW4iOiI2ZDA3NjZiZS1hMjc2LTQ3NzQtYmUxZS0yODk2YWNlZWY2MTYifQ.0hHSEpeZBblLkA0zi9bkxKXSiQKUCmqA0w4X8Q3Ibec', fre8ProAccessToken: 'F4B667BB54402165AAD4E5B9B0292A44', })
  //   navigate(`/pro/couchServicesHost?${params.toString()}`)
  //   // localStorage.setItem('Authorization', headers);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])


  // const userData = localStorage.getItem('Authorization'); // get the stored string
  const mainPageUrl = localStorage.getItem('mainPageUrl') || '';

  React.useEffect(() => {
    if (!authReady || !authToken) return;
    const firstSegment = location?.pathname?.split('/')[1] || '';
    console.log('---firstSegment--->', firstSegment)
    console.log('---location?.pathname--->', location?.pathname)
    console.log('---mainPageUrl--->', mainPageUrl)

    if (authToken) {
      LoginApis.whoamiUser(authToken)
        .then(async (res) => {
          if (res?.data?.success === false) {
            console.warn('API success=false');
            return;
          }

          console.log('----userInfo---->>', res?.data)
          const userInfo = res?.data?.data;
          if (userInfo) {
            const categoryStatusObj = {
              userId: userInfo?.userId,
              fre8ProAccessToken: userInfo?.fre8ProAccessToken,
              operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
              operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
              clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
            };

            try {
              const response = await AccountCategoryAPIs.getUserCategoryStatusBoolean(categoryStatusObj);
              if (response?.success && response?.data) {
                userInfo.accountCategoryVerified = response?.data?.verified;
                userInfo.categoryInfo = response?.data; // ✅ Add the whole object for clarity
                dispatch(setAccountCategoryVerificationStatus(response?.data?.verified))
              }
            } catch (err) {
              console.error('userCategoryStatusBoolean failed:', err);
            }
            let mobileNumberObj = {
              fre8ProAccessToken: userInfo?.fre8ProAccessToken,
              viewerUserId: userInfo?.userId,
              targetUserId: userInfo?.userId,
              operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
              operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
              clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
            }
            await ProfileApis.getUserPersonalDetails(mobileNumberObj)
              .then((res) => {
                // Dispatch FrProUser Add extra Keys
                dispatch(
                  setFrProUser({
                    frProUser: {
                      ...userInfo,
                      emailId: res?.data?.personalInfoForm?.email,
                      mobileNumber: res?.data?.personalInfoForm?.mobileNumber,
                      locationForm: res?.data?.personalInfoForm?.locationForm,
                      fullName: res?.data?.personalInfoForm?.firstName + ' ' + res?.data?.personalInfoForm?.lastName,
                      profileId: res?.data?.profileId,
                    },
                  })
                )
                dispatch(setEmailVerificationStatus(res?.data?.emailVerified))
                dispatch(setMobileVerificationStatus(res?.data?.mobileVerified));
              })
              .catch((err) => {
                console.debug('Mobile number not Available', err)
              })
          }
          const token = userInfo?.fre8ProAccessToken;
          // Store user info in Redux
          // dispatch(setFrProUser({ frProUser: userInfo }));

          // Save token to storage
          if (token) {
            sessionStorage.setItem('accessToken', JSON.stringify(token));
            localStorage.setItem('user', JSON.stringify({ fre8ProAccessToken: token }));
          }
          console.log('-----------11111---->', res?.data?.fre8ProStatus)
          console.log('-----------11111 === Standard---->', res?.data?.fre8ProStatus === 'Standard')
          console.log('-----------11111 === location?.pathname ===---->', location?.pathname === '/')
          console.log('-----------11111 === location?.pathname ===---->', location)
          console.log('-----------11111 === firstSegment === mainPageUrl ===---->', firstSegment)
          console.log('-----------11111 === firstSegment === mainPageUrl ===---->', mainPageUrl)
          console.log('-----------11111 === firstSegment === mainPageUrl ===---->', firstSegment === mainPageUrl)
          // Navigation logic
          if (res?.data?.fre8ProStatus === 'Standard') {
            console.log('---Fallback to dashboard---1');
            navigate('/profile', { username: 'test' });
          } else if (location?.pathname === '/') {
            console.log('---Fallback to dashboard---2');
            localStorage.removeItem('mainPageUrl')
            navigate('/dashboard', { username: 'test' });
          } else if (firstSegment === mainPageUrl) {
            console.log('---Fallback to dashboard---3');
            navigate(mainPageUrl && location?.pathname, { username: 'test' });
          } else {
            console.log('---Fallback to dashboard---4');
            localStorage.removeItem('mainPageUrl')
            navigate('/dashboard', { username: 'test' });
          }
        })
        .catch((err) => {
          console.error('whoamiUser failed:', err);
          console.log('whoamiUser failed:', err);
          localStorage.setItem('user', JSON.stringify({}));
          localStorage.removeItem('mainPageUrl');
          localStorage.removeItem('Authorization');
          navigate('/', { username: 'test' });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authReady, authToken]);

  // React.useEffect(() => {
  //   const firstSegment = location?.pathname?.split('/')[1] || '';
  //   console.log('---firstSegment--->', firstSegment)
  //   console.log('---location?.pathname--->', location?.pathname)
  //   console.log('---mainPageUrl--->', mainPageUrl)

  //   if (userData) {
  //     LoginApis.mobileWhoamiUser(userData)
  //       .then(async (res) => {
  //         if (res?.data?.success === false) {
  //           console.warn('API success=false');
  //           return;
  //         }

  //         const userInfo = res?.data?.data;
  //         if (userInfo) {
  //           const categoryStatusObj = {
  //             userId: userInfo?.userId,
  //             fre8ProAccessToken: userInfo?.fre8ProAccessToken,
  //             operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
  //             operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
  //             clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
  //           };

  //           try {
  //             const response = await AccountCategoryAPIs.getUserCategoryStatusBoolean(categoryStatusObj);
  //             if (response?.success && response?.data) {
  //               userInfo.accountCategoryVerified = response?.data?.verified;
  //               userInfo.categoryInfo = response?.data; // ✅ Add the whole object for clarity
  //               dispatch(setAccountCategoryVerificationStatus(response?.data?.verified))
  //             }
  //           } catch (err) {
  //             console.error('userCategoryStatusBoolean failed:', err);
  //           }
  //           let mobileNumberObj = {
  //             fre8ProAccessToken: userInfo?.fre8ProAccessToken,
  //             viewerUserId: userInfo?.userId,
  //             targetUserId: userInfo?.userId,
  //             operatedByUserId: process.env.REACT_APP_OPERATED_BY_USER_ID,
  //             operatedByModule: process.env.REACT_APP_OPERATED_BY_MODULE,
  //             clientDeviceType: process.env.REACT_APP_CLIENT_DEVICE_TYPE,
  //           }
  //           await ProfileApis.getUserPersonalDetails(mobileNumberObj)
  //             .then((res) => {
  //               // Dispatch FrProUser Add extra Keys
  //               dispatch(
  //                 setFrProUser({
  //                   frProUser: {
  //                     ...userInfo,
  //                     emailId: res?.data?.personalInfoForm?.email,
  //                     mobileNumber: res?.data?.personalInfoForm?.mobileNumber,
  //                     locationForm: res?.data?.personalInfoForm?.locationForm,
  //                     fullName: res?.data?.personalInfoForm?.firstName + ' ' + res?.data?.personalInfoForm?.lastName,
  //                     profileId: res?.data?.profileId,
  //                   },
  //                 })
  //               )
  //             })
  //             .catch((err) => {
  //               console.debug('Mobile number not Available', err)
  //             })
  //         }
  //         const token = userInfo?.fre8ProAccessToken;
  //         // Store user info in Redux
  //         // dispatch(setFrProUser({ frProUser: userInfo }));

  //         // Save token to storage
  //         if (token) {
  //           sessionStorage.setItem('accessToken', JSON.stringify(token));
  //           localStorage.setItem('user', JSON.stringify({ fre8ProAccessToken: token }));
  //         }
  //         console.log('-----------11111---->', res?.data?.fre8ProStatus)
  //         console.log('-----------11111 === Standard---->', res?.data?.fre8ProStatus === 'Standard')
  //         console.log('-----------11111 === location?.pathname ===---->', location?.pathname === '/')
  //         console.log('-----------11111 === location?.pathname ===---->', location)
  //         console.log('-----------11111 === firstSegment === mainPageUrl ===---->', firstSegment)
  //         console.log('-----------11111 === firstSegment === mainPageUrl ===---->', mainPageUrl)
  //         console.log('-----------11111 === firstSegment === mainPageUrl ===---->', firstSegment === mainPageUrl)
  //         // Navigation logic
  //         if (res?.data?.fre8ProStatus === 'Standard') {
  //           console.log('---Fallback to dashboard---1');
  //           navigate('/profile', { username: 'test' });
  //         } else if (location?.pathname === '/') {
  //           console.log('---Fallback to dashboard---2');
  //           localStorage.removeItem('mainPageUrl')
  //           navigate('/dashboard', { username: 'test' });
  //         } else if (firstSegment === mainPageUrl) {
  //           console.log('---Fallback to dashboard---3');
  //           navigate(mainPageUrl && location?.pathname, { username: 'test' });
  //         } else {
  //           console.log('---Fallback to dashboard---4');
  //           localStorage.removeItem('mainPageUrl')
  //           navigate('/dashboard', { username: 'test' });
  //         }
  //       })
  //       .catch((err) => {
  //         console.error('whoamiUser failed:', err);
  //         localStorage.setItem('user', JSON.stringify({}));
  //         localStorage.removeItem('mainPageUrl');
  //         localStorage.removeItem('Authorization');
  //         navigate('/', { username: 'test' });
  //       });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [authorization]);

  let userList = JSON.parse(localStorage.getItem('usersList'))
  userList =
    userList === '' || userList === null || userList === undefined
      ? []
      : userList
  localStorage.setItem('usersList', JSON.stringify(userList))

  let user = JSON.parse(localStorage.getItem('user'))
  user = user === '' || user === null || user === undefined ? {} : user
  localStorage.setItem('user', JSON.stringify(user))

  let loogedInUserbuddyList = JSON.parse(
    localStorage.getItem('loogedInUserbuddyList')
  )
  loogedInUserbuddyList =
    loogedInUserbuddyList === '' ||
      loogedInUserbuddyList === null ||
      loogedInUserbuddyList === undefined
      ? []
      : loogedInUserbuddyList
  localStorage.setItem(
    'loogedInUserbuddyList',
    JSON.stringify(loogedInUserbuddyList)
  )

  let requestSentToUserbuddyList = JSON.parse(
    localStorage.getItem('requestSentToUserbuddyList')
  )
  requestSentToUserbuddyList =
    requestSentToUserbuddyList === '' ||
      requestSentToUserbuddyList === null ||
      requestSentToUserbuddyList === undefined
      ? []
      : requestSentToUserbuddyList
  localStorage.setItem(
    'requestSentToUserbuddyList',
    JSON.stringify(requestSentToUserbuddyList)
  )

  let notificationList = JSON.parse(localStorage.getItem('notificationList'))
  notificationList =
    notificationList === '' ||
      notificationList === undefined ||
      notificationList === null
      ? []
      : notificationList
  localStorage.setItem('notificationList', JSON.stringify(notificationList))

  let usercategory = JSON.parse(localStorage.getItem('usercategory'))
  usercategory =
    usercategory === '' || usercategory === null || usercategory === undefined
      ? ''
      : usercategory
  localStorage.setItem('usercategory', JSON.stringify(usercategory))

  let userSession = JSON.parse(sessionStorage.getItem('userSession'))
  userSession =
    userSession === '' || userSession === null || userSession === undefined
      ? ''
      : userSession
  sessionStorage.setItem('userSession', JSON.stringify(userSession))

  // let accessToken = JSON.parse(sessionStorage.getItem('accessToken'));
  // accessToken = accessToken === '' || accessToken === null || accessToken === undefined ? {} : accessToken
  // sessionStorage.setItem('accessToken', JSON.stringify(accessToken));

  return (
    <UserSession>
      <Internationalization>
        <Routes />
      </Internationalization>
    </UserSession>
  )
}

export default App
